module.exports = function() {
  return new Worker(__webpack_public_path__ + "20e26c25dd2a1dae6adf.worker.js");
};